import { SortOrder } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';

export interface UserListProps {
    effectiveFilterText: string;
    checkedItemIds: string[];
    setCheckedItemIds: (items: string[]) => void;
}

export enum ColumnId {
    Avatar = 'avatar',
    Name = 'displayName',
    Email = 'userEmail',
    Role = 'role',
    Permissions = 'permissions',
    Status = 'status',
    TFA = 'TFA',
    Delegate = 'delegate',
    DelegateDateStart = 'delegateDateStart',
    DelegateDateEnd = 'delegateDateEnd',
    DelegateTimeZone = 'delegateTimeZone',
    UserMenu = 'userMenu',
    Checkbox = 'checkbox',
}

export type UserRow = selectors.types.ExpandedCompanyUser & { delegateTimeZone: string | undefined };

export interface Comparator<T = UserRow, R = any> {
    (a: T, b: T): R;
}

export interface SortState {
    columnId: string | undefined;
    sortOrder: SortOrder | undefined;
}
